<div class="flex w-full">
  <div class="px-7"></div>
  <button [attr.data-active]="active()" [attr.data-theme]="theme()">
    <ng-content />
  </button>
</div>
